import { _colors, getTheme as baseTheme } from '../themes';

const getPageBaseTheme = () => {
    const pageBaseTheme = baseTheme();
    pageBaseTheme.components.Typography.fontFamily = 'Roboto';

    return pageBaseTheme;
}

export const getPageTitleTheme = () => {
    const pageTitleTheme = getPageBaseTheme();
    pageTitleTheme.token.fontSizeHeading1 = 24;

    return pageTitleTheme;
}

export const getPageDescriptionTheme = () => {
    const pageDescriptionTheme = getPageBaseTheme();
    pageDescriptionTheme.components.Typography.fontSize = 16;

    return pageDescriptionTheme;
}

export const getMobileSendSMSFormTheme = () => {
    const newTheme = getPageBaseTheme();
    newTheme.components.Form = {
        itemMarginBottom: 0
    };
    return newTheme;
}